import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import { getFrontmatter, getMainFields } from "../../utils/functions";

const BoardSpecs = ({ category, slug }) => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        edges {
          node {
            id
            ...MCUFrontmatter
            ...SBCFrontmatter
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  const frontmatter = getFrontmatter(category);
  const fields = getMainFields(category);
  // console.log(frontmatter);
  const {
    node: {
      [frontmatter]: {
        specs,
        featured_image: { img },
      },
    },
  } = data.allMarkdownRemark.edges.find(
    ({ node }) => node.fields.slug === slug
  );
  // const fields = [
  //   { label: "Manufacurer", key: "manufacturer" },
  //   { label: "Microcontroller IC", key: "ic" },
  //   { label: "Frequency", key: "frequency" },
  //   { label: "Flash", key: "flashMemory" },
  //   { label: "RAM", key: "ram" },
  // ];

  return (
    <div className="my-8 w-full">
      <ul className="flex flex-col" style={{ margin: 0 }}>
        {(fields || []).map((field, i) => (
          <li key={i} className="flex flex-1 flex-row">
            <div className="flex-1 text-sm border-b bg-primary text-neutral-light-alt px-3 py-2 flex items-center font-bold break-words">
              {field.label}
            </div>
            <div className="flex-1 justify-center bg-primary-lighter px-3 py-2 border-b text-sm break-words">
              {specs[field.value]}
            </div>
          </li>
        ))}
        {/* <li className="flex flex-1 flex-row">
          <div className="flex-1 text-sm border-b bg-primary text-neutral-light-alt px-3 py-2 flex items-center font-bold">
            Check Price<span className="text-red-700">*</span>
          </div>
          <div className="flex-1 justify-center bg-primary-lighter px-3 py-2 border-b text-sm break-words">
            <a
              href="#!"
              className="bg-secondary hover:bg-secondary-light px-2 py-1 rounded text-white hover:text-white text-sm"
            >
              Amazon
            </a>
          </div>
        </li> */}
      </ul>
      {/* <div className="text-xs">
        <span className="text-red-700">*</span>Commission Earned
      </div> */}
    </div>
  );
};

export default BoardSpecs;
